import { PaymentMethodItem, VatRateItem } from '@skylab-shared/business';
import { IdentifiableValueConverter } from '@skylab-shared/core';
import {
    FiscalDevicePaymentMethodsParametersMappingModel,
    FiscalDeviceVatRatesParametersMappingModel,
    FiscalDeviceVatRatesParametersModel
} from '@skylab-shared/dataModel';

export class FiscalDevicePaymentMethodsParametersMappingModelWrapper {
    public constructor(
        public model: FiscalDevicePaymentMethodsParametersMappingModel,
        public paymentMethods: PaymentMethodItem[],
        public paymentMethodsConverter: IdentifiableValueConverter,
    ) {}

    public get paymentMethodName(): string {
        const paymentMethod = this.paymentMethods.find(
            (paymentMethod: PaymentMethodItem) => paymentMethod.id === this.model.paymentMethodId,
        );
        return paymentMethod ? paymentMethod.name : '';
    }
}

export class FiscalDeviceVatRatesParametersMappingModelWrapper {
    public constructor(
        public model: FiscalDeviceVatRatesParametersMappingModel,
        public parameters: FiscalDeviceVatRatesParametersModel,
        public physicalVatRateSymbol: string,
        public vatRates: VatRateItem[],
        public vatRatesConverter: IdentifiableValueConverter,
    ) {}

    private _technicalZero!: boolean;
    public get technicalZero() {
        return this.parameters.technicalZero === this.model.mapped;
    }

    public set technicalZero(value: boolean) {
        if (value) {
            this.parameters.technicalZero = this.model.mapped;
            this.model.vatRateId = null as any;
        } else {
            this.parameters.technicalZero = null as any;
        }
    }
}
